export const LAND_USE = {
  TILLABLE: "Tillable",
  TILLABLE_IRRIGATED: "Tillable",
  TILLABLE_NON_IRRIGATED: "Tillable",
  PASTURE: "Pasture",
  CRP_RESERVED: "Reserve program (CRP Acres)",
  WRP_RESERVED: "Reserve program (WRP Acres)",
  TIMBER: "Timber",
  HUNTING: "Hunting",
};

export const LISTING_STATUS = {
  ACTIVE: "ACTIVE",
  DRAFT: "DRAFT",
  EXPIRED: "Expired",
  IN_REVIEW: "In review",
  LEASED: "Leased",
  LEASE_PENDING: "Lease pending",
  PENDING_CONFIRMATION: "Pending confirmation",
};

export const DEFAULT_AGENT_CARD = {
  firstName: "Ezrah",
  lastName: "Berkson",
  fullName: "Ezrah Berkson",
  title: "CommonGround",
  email: "ezrah@commonground.io",
  phone: "(319) 541-6422",
  avatar: "/assets/images/defaul_agent_image.png",
};

export const TRANSACTION_TYPE = {
  SALE_NON_AUCTION: "SALE_NON_AUCTION",
  SALE_AUCTION: "SALE_AUCTION",
  LEASE: "LEASE",
};


export const COMMONGROUND_SESSION = {
  token: "commonground:accessToken",
  refreshToken: "commonground:refreshToken",
  impersonationTarget: "commonground:impersonationTarget",
};
